import { scroll } from 'motion';

document.addEventListener('DOMContentLoaded', () => {
	const containers = document.querySelectorAll(
		'.wp-block-improntad-theme-blocks-scroll-reveal-cards .scroll-reveal-cards-wrapper'
	);

	containers.forEach((container) => {
		const cards = Array.from(
			container.querySelectorAll('.scroll-reveal-card')
		);
		if (cards.length === 0) {
			return;
		}

		// Progressive z-index
		cards.forEach((card, i) => {
			card.style.zIndex = cards.length - i;
			card.style.position = 'relative'; // Ensure z-index applies
		});

		const stackOffset = 20;
		let naturalPositions = [];
		let totalExpansionNeeded = 0;

		const measure = () => {
			naturalPositions = cards.map((c) => c.offsetTop);
			const lastIdx = cards.length - 1;
			const lastNatural = naturalPositions[lastIdx];
			const firstNatural = naturalPositions[0];
			const lastStacked = firstNatural + lastIdx * stackOffset;

			totalExpansionNeeded = Math.max(0, lastNatural - lastStacked);
		};

		measure();
		window.addEventListener('resize', measure);

		scroll(
			(progress) => {
				if (!naturalPositions.length) {
					return;
				}

				let remainingExpansion = totalExpansionNeeded * progress;
				let currentVisualPosPrev = naturalPositions[0];

				cards.forEach((card, i) => {
					if (i === 0) {
						card.style.transform = 'translateY(0px)';
						currentVisualPosPrev = naturalPositions[0];
					} else {
						const naturalPos = naturalPositions[i];
						const stackedTarget =
							currentVisualPosPrev + stackOffset;

						const visualPos = Math.min(
							naturalPos,
							stackedTarget + remainingExpansion
						);

						const transformY = visualPos - naturalPos;
						card.style.transform = `translateY(${transformY}px)`;

						const expansionUsed = visualPos - stackedTarget;
						remainingExpansion = Math.max(
							0,
							remainingExpansion - expansionUsed
						);

						currentVisualPosPrev = visualPos;
					}
				});
			},
			{
				target: container,
				offset: ['start 70%', 'end 70%'],
			}
		);

		// Correcting the loop to use a local variable for budget
		// We need to re-bind the scroll handler to capture the logic correctly.
	});
});
